import {
	AppHomeContainer,
	WalletContainer,
	CustomerContainer,
	InvoiceContainer,
	SettingsContainer,
	PaymentLinkContainer,
	BookingContainer,
	TransactionsNewContainer,
	ApiKeysContainer,
} from '../containers';
import { PlansBilling } from '../pages';

import constant from '../utils/constant';

const protectedRoutes = [
	{
		path: constant.Routes.AppHome,
		module: 'TRANSACTION',
		type: 'GENERAL',
		element: <AppHomeContainer />,
	},
	{
		path: constant.Routes.Wallet,
		module: 'WALLET',
		type: 'GENERAL',
		element: <WalletContainer />,
	},
	{
		path: constant.Routes.Customer,
		module: 'CUSTOMER',
		element: <CustomerContainer />,
	},
	{
		path: constant.Routes.Invoice,
		module: 'INVOICE/RECEIPT',
		element: <InvoiceContainer />,
	},
	{
		path: constant.Routes.Transactions,
		module: 'TRANSACTION',
		type: 'GENERAL',
		element: <TransactionsNewContainer />,
	},
	{
		path: constant.Routes.Settings,
		element: <SettingsContainer />,
	},
	{
		path: constant.Routes.PaymentLink,
		element: <PaymentLinkContainer />,
	},
	{
		path: constant.Routes.Booking,
		element: <BookingContainer />,
	},
	{
		path: constant.Routes.TransactionsNew,
		module: 'TRANSACTION',
		type: 'GENERAL',
		element: <TransactionsNewContainer />,
	},
	{
		path: constant.Routes.ApiKeys,
		// module: 'TRANSACTION',
		type: 'GENERAL',
		element: <ApiKeysContainer />,
	},
	{
		path: constant.Routes.Billing,
		module: 'TRANSACTION',
		type: 'GENERAL',
		element: <PlansBilling />,
	},
];

export default protectedRoutes;
